<template>
  <div>
    <el-container>
      <el-menu :default-active="currentRouter" :unique-opened="true" router :collapse="isCollapse" :style="isCollapse ? 'min-width: 60px;height: 100vh;overflow:auto;' : 'min-width: 200px;height: 100vh;overflow:auto;'">
        <div class="mt-aside-title flex-justify-center">文森卡</div>
        <template v-for="(item, index) in childrenMenuList">
          <el-menu-item v-if="item.isHidden == 0 && item.menuType == 'C'" :index="String(item.component)">
            <template><i :class="item.icon"></i><span slot="title">{{item.name}}</span></template>
          </el-menu-item>
          <el-submenu v-if="item.isHidden == 0 && item.menuType == 'M'" :index="String(item.id)">
            <template slot="title"><i :class="item.icon"></i><span slot="title">{{item.name}}</span></template>
            <template v-for="(item2, index2) in item.children">
              <el-submenu v-if="item2.isHidden == 0 && item2.menuType == 'M'" :index="String(item2.id)">
                <template slot="title">{{item2.name}}</template>
                <el-menu-item v-for="(item3, index3) in item2.children" v-if="item3.isHidden == 0" :index="String(item3.component)">{{item3.name}}</el-menu-item>
              </el-submenu>
              <el-menu-item v-if="item2.isHidden == 0 && item2.menuType == 'C'" :index="String(item2.component)">{{item2.name}}</el-menu-item>
            </template>
          </el-submenu>
        </template>
        <!-- <el-submenu index="111">
          <template slot="title"><i class="el-icon-setting"></i><span slot="title">慧生活</span></template>
          <el-menu-item-group>
            <el-menu-item index="/wisdom_life_cate">分类</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/wisdom_life">视频</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
        <!-- <el-submenu index="1">
          <template slot="title"><i class="el-icon-s-goods"></i><span slot="title">商品</span></template>
          <el-menu-item-group>
            <el-menu-item index="/goods">商品管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/goods_cate">商品分类</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/goods_comment">商品评价</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/goods_tag">商品标签</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/service_note">服务说明</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/business_qualification">经营资质</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title"><i class="el-icon-s-order"></i><span slot="title">订单</span></template>
          <el-menu-item-group>
            <el-menu-item index="/order">订单管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/after_sale">退款管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title"><i class="el-icon-s-custom"></i><span slot="title">用户</span></template>
          <el-menu-item-group>
            <el-menu-item index="/user">用户管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/level">会员等级</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title"><i class="el-icon-s-grid"></i><span slot="title">分销</span></template>
          <el-menu-item-group>
            <el-menu-item index="/commission">分销设置</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/commission_member">分销员管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/commission_report_form">分销报表</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/dl_apply">代理申请</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/branch_office">分公司</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/agency_channel">代理渠道</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
        <!-- <el-submenu index="4">
          <template slot="title"><i class="el-icon-setting"></i><span slot="title">基础配置</span></template>
          <el-menu-item-group>
            <el-menu-item index="/service_agreement">用户服务协议</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/privacy_policy">隐私政策</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
        <!-- <el-submenu index="5">
          <template slot="title"><i class="el-icon-s-finance"></i><span slot="title">财务</span></template>
          <el-menu-item-group>
            <el-menu-item index="/finance">财务管理</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title"><i class="el-icon-picture"></i><span slot="title">内容</span></template>
          <el-menu-item-group>
            <el-menu-item index="/banner">轮播图</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/jg">金刚区</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/popup">弹框广告</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="7">
          <template slot="title"><i class="el-icon-picture"></i><span slot="title">营销功能</span></template>
          <el-submenu index="7-1">
            <template slot="title">礼品卡</template>
            <el-menu-item index="/gift_card_manage">礼品卡管理</el-menu-item>
            <el-menu-item index="/gift_card_order">礼品卡订单</el-menu-item>
            <el-menu-item index="/card_encryption_record">卡密记录</el-menu-item>
          </el-submenu>
          <el-menu-item index="/gift_promotion">赠品活动</el-menu-item>
          <el-submenu index="7-2">
            <template slot="title">余额充值</template>
            <el-menu-item index="/recharge_amount">充值金额</el-menu-item>
            <el-menu-item index="/recharge_record">充值记录</el-menu-item>
            <el-menu-item index="/recharge_config">充值配置</el-menu-item>
          </el-submenu>
          <el-submenu index="7-3">
            <template slot="title">拼团活动</template>
            <el-menu-item index="/group_goods">拼团商品</el-menu-item>
            <el-menu-item index="/group_list">拼团列表</el-menu-item>
          </el-submenu>
          <el-submenu index="7-4">
            <template slot="title">秒杀活动</template>
            <el-menu-item index="/seckill_list">秒杀列表</el-menu-item>
            <el-menu-item index="/goods_list">商品列表</el-menu-item>
            <el-menu-item index="/seckill_order">秒杀订单</el-menu-item>
          </el-submenu>
          <el-menu-item index="/activity_goods_list">活动专区</el-menu-item>
          <el-menu-item index="/benefits_goods_list">新人活动</el-menu-item> -->
          <!-- <el-submenu index="7-5">
            <template slot="title">积分</template>
            <el-menu-item index="/integral_config">积分配置</el-menu-item>
            <el-menu-item index="/integral_extra_checkIn">额外签到积分</el-menu-item>
            <el-menu-item index="/integral_special">特殊签到积分</el-menu-item> -->
            <!-- <el-menu-item index="/integral_mall_task">积分任务</el-menu-item> -->
            <!-- <el-menu-item index="/integral_mall">积分商城</el-menu-item>
            <el-menu-item index="/integral_mall_order">积分订单</el-menu-item>
          </el-submenu> -->
          <!-- <el-submenu index="7-6">
            <template slot="title">优惠券</template>
            <el-menu-item index="/coupon">优惠券列表</el-menu-item>
            <el-menu-item index="/coupon_get_record">领取记录</el-menu-item>
            <el-menu-item index="/coupon_center">领取中心</el-menu-item>
          </el-submenu>
          <el-menu-item index="/set_menu">套餐搭配</el-menu-item>
          <el-menu-item index="/video">硒生活</el-menu-item>
          <el-submenu index="7-7">
            <template slot="title">拉新活动</template>
            <el-menu-item index="/lx_config">拉新配置</el-menu-item>
            <el-menu-item index="/lx_record">拉新记录</el-menu-item>
          </el-submenu>
          <el-menu-item index="/discount">折扣活动</el-menu-item>
          <el-submenu index="7-8">
            <template slot="title">砍价</template>
            <el-menu-item index="/bargain_activity">砍价商品</el-menu-item>
            <el-menu-item index="/bargain_order">砍价订单</el-menu-item>
          </el-submenu>
          <el-submenu index="7-9">
            <template slot="title">抽奖</template>
            <el-menu-item index="/prize_draw">抽奖配置</el-menu-item>
            <el-menu-item index="/prize_draw_record">中奖记录</el-menu-item>
          </el-submenu>
          <el-menu-item index="/sms_config">营销短信</el-menu-item>
        </el-submenu>
        <el-submenu index="8">
          <template slot="title"><i class="el-icon-s-help"></i><span slot="title">配置</span></template>
          <el-menu-item-group>
            <el-menu-item index="/setting">系统配置</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/manager">管理员管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/role">角色管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/pickup">自提点管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/delivery">配送模版</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="9">
          <template slot="title"><i class="el-icon-s-marketing"></i><span slot="title">经销商</span></template>
          <el-menu-item-group>
            <el-menu-item index="/agent_management">代理管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/agent_order">代理订单</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="10">
          <template slot="title"><i class="el-icon-s-marketing"></i><span slot="title">硒游记</span></template>
          <el-menu-item-group>
            <el-menu-item index="/xyj_bases">基地管理</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/bases_goods_list?dataId=">基地商品</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <el-menu-item index="/order">基地订单</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
      </el-menu>

      <el-container>
         <!-- style="position: fixed;right: 0;left:0;top: 0;z-index: 100;" -->
        <el-header class="flex-between">
          <div class="flex-row-align">
            <div class="mt-aside-open" @click="collapseTapBtn">
              <i :class="isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
            </div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
               <!-- :to="{ path: item.component }" -->
              <el-breadcrumb-item v-for="(item,index) in routerData"  :key="index">{{item.name}}</el-breadcrumb-item>
              <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            </el-breadcrumb>
          </div>
          <el-dropdown>
            <span class="el-dropdown-link">
             {{userName}} <i class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="exitBtn">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>

        <el-main style="background-color: #F9F9F9;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { exitBtn } from '@/api/index'
export default {
  name: 'Home',
  data () {
    return {
      imgServer: this.$imgServer,
      isCollapse: false,
      childrenMenuList:[],
      currentRouter: '/index',
      userName: '',
      userInfo: {
        name: ''
      },
      routerData: []
    }
  },
  watch: {
    '$route' (to, from) {
      // 根据to.path判断当前页面并执行相应逻辑
      this.currentRouter = to.path
      this.pathFun(to.path)
    }
  },
  created() {
    var childrenMenuList = sessionStorage.getItem('childrenMenuList')
    this.childrenMenuList = JSON.parse(childrenMenuList);
    // console.log(JSON.parse(childrenMenuList),'JSON.stringify(childrenMenuList)')
  },
  methods: {
    // 菜单栏折叠操作
    collapseTapBtn () {
      this.isCollapse = !this.isCollapse
    },
    pathFun (path) {
      var that = this
      var childrenMenuList = that.childrenMenuList;
      var currentRouter = that.currentRouter;
      var routerData = [];
      for(var i = 0 ; i < childrenMenuList.length ; i++){
        // 第一级
        if(path == childrenMenuList[i].component){
          routerData.push({
            component:childrenMenuList[i].component,
            name:childrenMenuList[i].name
          })
          //跳出循环
          break;
        }
        if(childrenMenuList[i].children != null){
          for(var j = 0 ; j < childrenMenuList[i].children.length ; j++){
            // 第二级
            if(path == childrenMenuList[i].children[j].component){
              routerData.push({
                component:childrenMenuList[i].component,
                name:childrenMenuList[i].name
              },{
                component:childrenMenuList[i].children[j].component,
                name:childrenMenuList[i].children[j].name
              })
              //跳出循环
              break;
            }
            if(childrenMenuList[i].children[j].children != null){
              for(var k = 0 ; k < childrenMenuList[i].children[j].children.length ; k++){
                // 第三级
                if(path == childrenMenuList[i].children[j].children[k].component){
                  routerData.push({
                    component:childrenMenuList[i].component,
                    name:childrenMenuList[i].name
                  },{
                    component:childrenMenuList[i].children[j].component,
                    name:childrenMenuList[i].children[j].name
                  },{
                    component:childrenMenuList[i].children[j].children[k].component,
                    name:childrenMenuList[i].children[j].children[k].name
                  })
                  //跳出循环
                  break;
                }
              }
            }
          }
        }
      }
      // console.log(routerData,'routerData');
      this.routerData = routerData;
    },
    /* 退出登录操作 */
    exitBtn () {
      let that = this
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        exitBtn({}).then((res) => {})
        sessionStorage.clear()
        that.$router.push('/login')
        that.$router.go(0)
      }).catch(() => {})
    }
  },
  mounted () {
    var token = sessionStorage.getItem('token')
    if (token === '' || token === null) {
      this.$router.push('/login')
    }
    var path = this.$route.path
    this.currentRouter = path
    this.pathFun(path)
    var userInfo = sessionStorage.getItem('user_info')
    this.userInfo = JSON.parse(userInfo)
    var userName = sessionStorage.getItem('userName')
    this.userName = userName;
    // window.οnbefοreunlοad = () => {
    //   // 退出登录
    //   exitBtn({}).then((res) => {})
    // }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
  .el-main {height: calc(100vh - 60px);}
</style>



// WEBPACK FOOTER //
// src/pages/home/Layout.vue